import React, { useState } from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import Button from '../../../../Components/Button/Button';
import BaseModal from '../../../Base/Components/BaseModal/BaseModal';
import CustomSignature from './CustomSignature';
import { Size } from '../../../../Enums/Size.enum';

const CustomSignatureWrapper: React.FC = () => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			<Button
				title='component.customSignature.button'
				theme={Theme.BLUE}
				onClick={() => setIsOpen(true)}
				className='mt-4'
			/>
			{isOpen && (
				<BaseModal
					isOpen
					title='component.customSignature.modalTitle'
					onClose={() => setIsOpen(false)}
					size={Size.SM}>
					<CustomSignature onSuccess={() => setIsOpen(false)} />
				</BaseModal>
			)}
		</>
	);
};

export default CustomSignatureWrapper;
